<template>
  <div v-if="actions.length" class="booking-manual-actions">
    <app-actions-menu ref="menu" :actions="actions" @select="open" />
    <booking-manual-action-modal :name="modalName" :booking="booking" :action="selected" @updated="$emit('updated', $event)" @closed="closed" />
  </div>
</template>

<script>
import AppActionsMenu from '@/components/AppActionsMenu.vue'
import BookingManualActionModal from './BookingManualActionModal.vue'
import { bookingManualActions } from './booking-manual-actions'

export default {
  name: 'BookingManualActions',
  components: { AppActionsMenu, BookingManualActionModal },
  props: { booking: { type: Object, required: true } },
  data() { return { selected: null, requestId: 0 } },
  computed: {
    actions() { return bookingManualActions(this.booking) },
    modalName() { return `booking-manual-action-${this.booking.id}` }
  },
  beforeDestroy() { this.requestId++ },
  methods: {
    async open(action) {
      const allowed = this.actions.find(item => item.code === action.code)
      if (this.selected || !allowed) return
      const requestId = ++this.requestId
      const bookingId = this.booking.id
      this.selected = allowed
      await this.$nextTick()
      if (requestId === this.requestId && bookingId === this.booking.id && this.actions.some(item => item.code === action.code)) this.$modal.show(this.modalName)
      else this.selected = null
    },
    closed() {
      this.selected = null
      if (this.$refs.menu) this.$refs.menu.focusToggle()
    }
  }
}
</script>
